import { runInAction } from 'mobx';
import { logger } from '../../../../utils/logger';
import { obfuscateString } from '../../../../utils/obfuscation-utils';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { loyaltyDomainStore } from '../../store';
export const saveEmailAvailability = async (email, availability) => {
    if (!nonEmptyStringValidator(email, logger.error, 'saveEmailAvailability')) {
        throw new Error('No email was provided');
    }
    if (!availability) {
        throw new Error('No availability data was provided');
    }
    const obfuscatedValue = await obfuscateString(email);
    runInAction(() => {
        loyaltyDomainStore.data.emailAvailability = {
            lastValidatedEmail: obfuscatedValue,
            isAvailable: availability.isAvailable
        };
    });
};
